import {Component, Type} from '@wonderlandengine/api';

export class Link extends Component {
    static TypeName = 'link';
    static Properties = {
        url: {type: Type.String, default: 'https://wonderlandengine.com/vr'},
        openInNewTab: {type: Type.Bool, default: true},
    };

    start() {
        const target =
            this.object.getComponent('cursor-target') ||
            this.object.addComponent('cursor-target');

        target.addClickFunction(() => {
            if (this.openInNewTab) {
                window.open(this.url, '_blank');
            } else {
                window.location = this.url;
            }
        });
    }
}

export class BackLink extends Component {
    static TypeName = 'back-link';
    static Properties = {};

    start() {
        const target =
            this.object.getComponent('cursor-target') ||
            this.object.addComponent('cursor-target');
        target.addClickFunction(() => {
            history.back();
        });
    }
}
